import { SET_AI_SCORES_DATA } from '../constants/ActionTypes.js';

export const defaultState = {
  scores: [],
};

export const scores = (state = defaultState, action) => {
  switch (action.type) {
    case SET_AI_SCORES_DATA: {
      const newScores = state.scores.filter(
        s => s.objectUid !== action.data.objectUid
      );
      newScores.push(action.data);
      return {
        scores: newScores,
      };
    }
    default:
      return state;
  }
};
